var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRubleBig(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 20,
    viewBox: "0 0 17 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.24 19.992V0H8.624C11.2 0 13.076 0.522666 14.252 1.568C15.4467 2.61333 16.044 4.05067 16.044 5.88C16.044 6.96267 15.8013 7.98 15.316 8.932C14.8307 9.884 14.0187 10.6493 12.88 11.228C11.76 11.8067 10.2293 12.096 8.288 12.096H6.468V19.992H2.24ZM0 16.996V14.28H10.78V16.996H0ZM0 12.096V8.624H8.204V12.096H0ZM7.868 8.624C8.67067 8.624 9.36133 8.54 9.94 8.372C10.5187 8.18533 10.9667 7.896 11.284 7.504C11.6013 7.112 11.76 6.61733 11.76 6.02C11.76 5.16133 11.4893 4.52667 10.948 4.116C10.4067 3.68667 9.55733 3.472 8.4 3.472H6.468V8.624H7.868Z",
    fill: "#383838"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRubleBig);
export default __webpack_public_path__ + "static/media/rubleBig.127760a27b21fe35e067af87aaeb4045.svg";
export { ForwardRef as ReactComponent };